<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12 ">
        <div class="card mt-3">
          <div class="card-header mb-0">
            <div class="row no-gutters">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5>{{ $t('content.ssetbranch') }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="table-responsive">
                <table class="table table-flush mb-2">
                  <thead>
                    <tr>
                      <th colspan="2">{{ $t('content.activity') }}</th>
                    </tr>
                  </thead>
                  <tbody>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_code') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="code" type="text" v-model="shop_detail.code" class="mb-0" disabled />
                        </div>
                      </td>
                    </tr>


                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_fname') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="fname" type="text" v-model="shop_detail.fullname" class="mb-0" disabled />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.caddress') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="caddress" type="text" v-model="shop_detail.address" class="mb-0"
                            disabled />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_telnum') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <InputMask v-model="shop_detail.shopPhoneNumber" mask="(999) 999-9999" fluid />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_ipslip') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <input type="text" inputGroup :formOutline="false" :value="ipvalue" v-imask="ipmask" @accept="
                            (e) => {
                              ipvalue = e.detail.value;
                            }" class="form-control" style="font-size: 15px;"
                            :class="[isValid(regIP, ipvalue) ? '' : 'border-danger']" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class=" ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_taxId') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="taxId" type="text" v-model="shop_detail.taxId" class="mb-0" disabled />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_owner') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="owner" type="text" v-model="shop_detail.shopOwner" class="mb-0" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_shcusuid') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <div class="input-group">
                            <input v-model="cusName_search" type="text" class="form-control"
                              style="margin-bottom: 0 !important" readonly />
                            <button id="searchNameOwner" class="btn btn-primary mb-0" type="button"
                              @click="openDialogCus">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </button>
                            <button class="btn btn-danger mb-0" type="button" @click="clearCus"
                              :disabled="cusName_search === ''">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </button>
                            <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                              data-bs-target="#searchNameModal" v-show="false">
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_dueper') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="dueper" type="text" v-model="shop_detail.duePeroid" class="mb-0"
                            disabled />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_finglice') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="finglice" type="text" v-model="shop_detail.fscanLicense" class="mb-0" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_scorefing') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <InputNumber id="scorefing" v-model="shop_detail.fmatchScore" autocomplete="off"
                            @focus="$event.target.select()" fluid :min="0" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_lineId') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <material-input id="lineId" type="text" v-model="shop_detail.shopLineId" class="mb-0" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.enaoutage') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="ms-auto">
                          <ToggleSwitch v-model="shop_detail.outageMode"
                            class="form-check form-switch mb-0 align-items-center justify-content-left ms-1" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_cover') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="ms-auto">
                          <ToggleSwitch v-model="shop_detail.printCoverTicket"
                            class="form-check form-switch mb-0 align-items-center justify-content-left ms-1" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_minlimit') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <InputNumber id="minlimit" v-model="shop_detail.ticketMinLimit" autocomplete="off"
                            @focus="$event.target.select()" fluid :min="0" />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td class="ps-1 align-middle">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.stimgshop') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto d-flex gap-3 flex-wrap pt-3">
                          
                          <!-- กล่องที่ 1: รูปข้อมูล -->
                          <div class="card p-0 text-center d-flex flex-column align-items-center justify-content-between position-relative" 
                              style="width: 48%; min-width: 300px; min-height: 290px; border: 1px solid #ced4da; border-radius: 12px; background: #fff; overflow: hidden;">
                            
                            <!-- โซนรูปภาพด้านบน + เส้นขอบแบ่งด้านล่าง (border-bottom) -->
                            <div class="w-100 d-flex align-items-center justify-content-center p-3" 
                                style="height: 170px; overflow: hidden; border-bottom: 1px solid #e9ecef; background-color: #fafafa;">
                              <img v-if="previews.img1" :src="previews.img1" alt="รูปข้อมูล" style="max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 6px;" />
                              <template v-else>
                                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100" style="background-color: #f8f9fa; border-radius: 8px;">
                                  <span class="text-muted small">No image</span>
                                </div>
                              </template>
                            </div>

                            <!-- โซนด้านล่าง (ข้อความระบุชื่อ + ปุ่มกดเลือกรูป) -->
                            <div class="w-100 p-3 d-flex flex-column align-items-center justify-content-center flex-grow-1">
                              <div class="mb-2">
                                <span class="text-dark small fw-semibold">รูปข้อมูลสาขา</span>
                              </div>

                              <label class="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 px-4 py-2 text-sm m-0" 
                                    style="border-radius: 8px; cursor: pointer; background-color: #4b88ff; border-color: #4b88ff; width: auto; min-width: 140px;">
                                เลือกรูปภาพ
                                <input type="file" class="d-none" accept="image/*" @change="handleFileChange($event, 'img1')" />
                              </label>
                            </div>
                          </div>
                          
                          <!-- กล่องที่ 2: รูปแสตมป์ -->
                          <div class="card p-0 text-center d-flex flex-column align-items-center justify-content-between position-relative" 
                              style="width: 48%; min-width: 300px; min-height: 290px; border: 1px solid #ced4da; border-radius: 12px; background: #fff; overflow: hidden;">
                            
                            <!-- โซนรูปภาพด้านบน + เส้นขอบแบ่งด้านล่าง (border-bottom) -->
                            <div class="w-100 d-flex align-items-center justify-content-center p-3" 
                                style="height: 170px; overflow: hidden; border-bottom: 1px solid #e9ecef; background-color: #fafafa;">
                              <img v-if="previews.img2" :src="previews.img2" alt="รูปแสตมป์" style="max-width: 100%; max-height: 100%; object-fit: contain; border-radius: 6px;" />
                              <template v-else>
                                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100" style="background-color: #f8f9fa; border-radius: 8px;">
                                  <span class="text-muted small">No image</span>
                                </div>
                              </template>
                            </div>

                            <!-- โซนด้านล่าง (ข้อความระบุชื่อ + ปุ่มกดเลือกรูป) -->
                            <div class="w-100 p-3 d-flex flex-column align-items-center justify-content-center flex-grow-1">
                              <div class="mb-2">
                                <span class="text-dark small fw-semibold">รูปแสตมป์สาขา</span>
                              </div>

                              <label class="btn btn-primary d-inline-flex align-items-center justify-content-center gap-2 px-4 py-2 text-sm m-0" 
                                    style="border-radius: 8px; cursor: pointer; background-color: #4b88ff; border-color: #4b88ff; width: auto; min-width: 140px;">
                                เลือกรูปภาพ
                                <input type="file" class="d-none" accept="image/*" @change="handleFileChange($event, 'img2')" />
                              </label>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>




                    <tr>
                      <td class="ps-1">
                        <div class="my-auto">
                          <span class="text-dark d-block text-lg">
                            {{ $t('content.branch_openday') }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="my-auto">
                          <div v-for="option in workday" :key="option" class="grid-container">
                            <div class="row no-gutters">
                              <div class="col-12 d-flex align-items-center">
                                <div class="col-2 me-3 mt-4">
                                  <material-checkbox v-model="option.chk" :checked="option.chk"
                                    @change="onselectDate(option)">
                                    <label class="font-bold block mb-2">
                                      {{ option.items }}
                                    </label>
                                  </material-checkbox>
                                </div>
                                <div class="me-3 mt-1">
                                  <label for="timeonly_start" class="font-bold block mb-2"> {{ $t('content.opentime') }}
                                  </label>&nbsp;&nbsp;
                                  <DatePicker id="timeonly_start" v-model="option.time_starts" timeOnly variant="filled"
                                    :disabled="!option.chk">
                                  </DatePicker>
                                </div>
                                <div class="me-3 mt-1">
                                  <label for="timeonly_end" class="font-bold block mb-2"> {{ $t('content.closetime') }}
                                  </label>&nbsp;&nbsp;
                                  <DatePicker id="timeonly_end" v-model="option.time_ends" timeOnly variant="filled"
                                    :disabled="!option.chk">
                                  </DatePicker>
                                </div>
                              </div>
                            </div>
                          </div>
                          <pre></pre>
                        </div>
                      </td>
                    </tr>
                    <pre></pre>
                    <tr>
                      <td colspan="2" class="ps-1">
                        <div class="row no-gutters">
                          <div class="col-12 d-flex justify-content-end align-items-center">
                            <div class="me-3">
                              <material-button color="primary" class="float-lg-start float-sm-end mb-0" :title="btnSave"
                                @click="checkshopdata">
                                <i class="material-icons material-symbols-outlined">save</i> {{ btnSave }}
                              </material-button>
                            </div>
                            <div class="me-3">
                              <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-0"
                                @click="getshopInfo">
                                <i class="material-icons material-symbols-outlined">close</i>
                                {{ $t('buttons.canc') }}
                              </material-button>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Search Customer Dialog -->
            <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                      <i class="material-icons material-symbols-outlined">close</i>
                    </button>
                  </div>

                  <div class="modal-body">
                    <div class="preview-table">
                      <section class="panel">
                        <table class="table table-striped table-responsive">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>{{ $t("content.cnameth") }}</th>
                              <th>{{ $t("content.cnameen") }}</th>
                              <th>{{ $t("content.docno") }}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="row-search">
                              <td></td>
                              <td>
                                <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                              </td>
                              <td>
                                <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                              </td>
                              <td>
                                <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                              </td>
                              <td>
                                <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                                  data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                                  :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                                  @click="loadCustomerAfListApi">
                                  <i class="material-icons material-symbols-outlined">search</i>
                                </material-button>
                              </td>
                            </tr>
                            <tr v-for="(row, index) in customerlist" :key="index" @click="selectCus(row)">
                              <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                              <td>{{ row.nameTh }}</td>
                              <td>{{ row.nameEn }}</td>
                              <td colspan="2">{{ row.docNumber }}</td>
                            </tr>
                            <tr v-if="customerlist.length === 0">
                              <td colspan="5" class="text-sm font-weight-normal">
                                <p style="text-align: center">No Record Found</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <pre></pre>
                    <div style="display: flex; justify-content: flex-end">
                      <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                        <div class="project-container">
                          <div class="example-one">
                            <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                              :items-per-page="perPageC" @click="onClickHandlerC" />
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from 'vue'
import { useI18n } from "vue-i18n"

import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import MaterialButton from "@/components/MaterialButton.vue"
import MaterialInput from "@/components/MaterialInput.vue"
import MaterialSwitch from '@/components/MaterialSwitch.vue'
import InputNumber from 'primevue/inputnumber';
import InputMask from 'primevue/inputmask';
import DatePicker from 'primevue/datepicker';
import ToggleSwitch from 'primevue/toggleswitch';
import noImg from "@/assets/img/noimg.png"
import moment from 'moment'


import { useShopStore } from '@/stores/shop'
import { useCustomerStore } from '@/stores/customer'
import { useDocumentStore } from '@/stores/document'

const stores = useShopStore()
const storecus = useCustomerStore()
const storedoc = useDocumentStore()

const { t } = useI18n()
const swal = inject('$swal')

const btnSave = computed(() => t("buttons.save"))

const shop_detail = ref({})
const workday = ref(
  [
    { items: computed(() => t("content.mon")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.tue")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.wed")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.thu")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.fri")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.sat")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
    { items: computed(() => t("content.sun")), chk: false, time_starts: new Date(new Date().setHours(0, 0)), time_ends: new Date(new Date().setHours(23, 59)) },
  ])

const cusUid_search = ref('');
const cusName_search = ref('');
const customerlist = ref([])

const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();

const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')

const thumb_id_1 = ref(null)
const thumb_id_2 = ref(null)

const ipvalue = ref('')
const ipmask = ref({
  mask: "0[00]{.}0[00]{.}0[00]{.}0[00]",
  lazy: false,
})
const regIP = ref('^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)(\\.(?!$)|$)){4}$')

const fileData = reactive({
  img1: { base64: '', name: '', mimeType: '', isNewFile: false },
  img2: { base64: '', name: '', mimeType: '', isNewFile: false }
})

const previews = reactive({
  img1: '',
  img2: ''
})

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const onClickHandlerC = (page) => {
  updatePaginationC()
};

const loadDataShop = async () => {
  if (localStorage.getItem("shop_seleted") !== null) {
    await getshopInfo()
  }
};

loadDataShop();


function onselectDate(item) {
  if (item.chk === false) {
    item.time_starts = new Date(new Date().setHours(0, 0));
    item.time_ends = new Date(new Date().setHours(23, 59));
  }
};

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

async function getshopInfo() {
  previews.img1 = '';
  previews.img2 = '';
  fileData.img1 = { base64: '', name: '', mimeType: '', isNewFile: false };
  fileData.img2 = { base64: '', name: '', mimeType: '', isNewFile: false };
  shop_detail.value = {};
  cusUid_search.value = '';
  cusName_search.value = '';
  ipvalue.value = '';

  workday.value = workday.value.map(function (x) {
    x.chk = false;
    x.time_starts = new Date(new Date().setHours(0, 0));
    x.time_ends = new Date(new Date().setHours(23, 59));
    return x
  });

  let data = "";
  data = {
    uid: key.uid,
  };

  const payload = data;
  const response = await stores.shopInfoFetch(payload);
  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data;
        
        // หากฝั่ง Backend ส่งค่ามาเป็น '0' หรือไม่มีค่า รูปจะถูกเคลียร์เป็น "No Image" ตั้งแต่บรรทัดบนสุดแล้ว
        if (shop_detail.value.infoImgUid !== '0' && shop_detail.value.infoImgUid !== null && shop_detail.value.infoImgUid !== '') {
          await getFileImg(shop_detail.value.infoImgUid, key.uid, 'img1');
        }
        if (shop_detail.value.stampImgUid !== '0' && shop_detail.value.stampImgUid !== null && shop_detail.value.stampImgUid !== '') {
          await getFileImg(shop_detail.value.stampImgUid, key.uid, 'img2');
        }
        
        if (shop_detail.value.businessDay.length > 0) {
          for (let i = 0; i < shop_detail.value.businessDay.length; i++) {
            if (shop_detail.value.businessDay[i].includes('MONDAY')) {
              workday.value[0].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('TUESDAY')) {
              workday.value[1].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('WEDNESDAY')) {
              workday.value[2].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('THURSDAY')) {
              workday.value[3].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('FRIDAY')) {
              workday.value[4].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('SATURDAY')) {
              workday.value[5].chk = true;
            }
            if (shop_detail.value.businessDay[i].includes('SUNDAY')) {
              workday.value[6].chk = true;
            }
          }
        }
        cusUid_search.value = shop_detail.value.shopCusUid
        ipvalue.value = shop_detail.value.slipPrinterIP
        if (cusUid_search.value !== '' && cusUid_search.value !== null && cusUid_search.value !== '0') {
          await customerInfo(cusUid_search.value)
        }
      }
    }
  }
}


function isValid(reg, input) {
  return input !== "" && input !== null && input !== '_._._._' ? new RegExp(reg).test(input) : true;
}

async function checkshopdata() {
  if (ipvalue.value !== null && ipvalue.value !== '' && ipvalue.value !== '_._._._') {
    if (!isValid(regIP.value, ipvalue.value)) {
      swal("กรอก IP Address ไม่ถูกต้อง", "", "error");
    } else {
      await updateshopdata()
    }
  } else {
    await updateshopdata()
  }

}

async function updateshopdata() {
  // =========================================================================
  // ส่วนที่ 1: ตรวจสอบและอัปโหลดรูปภาพใหม่ขึ้นเซิร์ฟเวอร์ก่อน (แทรกเพิ่มตรงนี้)
  // =========================================================================
  for (const key of ['img1', 'img2']) {
    // เช็กว่ามีข้อมูล Base64 และระบุว่าเป็นไฟล์ที่เพิ่งเลือกเข้ามาใหม่ผ่านหน้าเว็บจริง
    if (fileData[key].base64 && fileData[key].isNewFile) {
      
      let trimmedString = cleanBase64(fileData[key].base64);
      let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
      let thumb_name = 'shopImg_' + today
      let filePayload = {
        forGroupUid: "",
        forShopUid: "",
        name: thumb_name,
        data: trimmedString,
        mimeType: fileData[key].mimeType,
      };

      // เรียก API ดั้งเดิมของคุณอัปโหลดไฟล์เข้าไปเพื่อขอ UID ชุดใหม่กลับมา
      const fileResponse = await storedoc.addFetch(filePayload);
      
      if (fileResponse && fileResponse.status === 200 && fileResponse.data.rtnDesc === "success") {
        const newFileUid = fileResponse.data.data.uid;
        
        // นำค่า UID ที่สร้างใหม่ ไปอัปเดตใส่ลงตัวแปรฟิลด์รูปให้ตรงตามโครงสร้างฐานข้อมูล
        if (key === 'img1') {
          shop_detail.value.infoImgUid = newFileUid;
        } else if (key === 'img2') {
          shop_detail.value.stampImgUid = newFileUid;
        }
      } else {
        // หากอัปโหลดรูปภาพใดรูปภาพหนึ่งล้มเหลว จะเด้งเตือนและหยุดการทำงานทั้งหมดทันที เพื่อความปลอดภัยของข้อมูล
        swal("บันทึกไฟล์รูปภาพไม่สำเร็จ", fileResponse?.data?.rtnDesc || "", "error");
        return; 
      }
    }
  }

  // =========================================================================
  // ส่วนที่ 2: จัดการเตรียม Payload และส่งข้อมูลอัปเดตร้านค้า (โค้ดเดิมของคุณทั้งหมด)
  // =========================================================================
  const payload = shop_detail.value;

  if (ipvalue.value !== null && ipvalue.value !== '' && ipvalue.value !== '_._._._') {
    payload.slipPrinterIP = ipvalue.value.trim()
  } else {
    payload.slipPrinterIP = null
  }

  if (payload.shopOwner !== null) {
    payload.shopOwner = payload.shopOwner.trim()
  }

  if (payload.fscanLicense !== null) {
    payload.fscanLicense = payload.fscanLicense.trim()
  }

  if (payload.shopLineId !== null) {
    payload.shopLineId = payload.shopLineId.trim()
  }

  if (payload.shopPhoneNumber !== null) {
    payload.shopPhoneNumber = payload.shopPhoneNumber.replace(/[^\d]/g, "")
  }

  if (payload.fmatchScore === null || payload.fmatchScore === undefined || payload.fmatchScore === "") {
    payload.fmatchScore = 0
  }

  payload.shopCusUid = cusUid_search.value
  payload.businessDay = [];

  if (workday.value[0].chk) {
    payload.businessDay.push('MONDAY');
  }
  if (workday.value[1].chk) {
    payload.businessDay.push('TUESDAY');
  }
  if (workday.value[2].chk) {
    payload.businessDay.push('WEDNESDAY');
  }
  if (workday.value[3].chk) {
    payload.businessDay.push('THURSDAY');
  }
  if (workday.value[4].chk) {
    payload.businessDay.push('FRIDAY');
  }
  if (workday.value[5].chk) {
    payload.businessDay.push('SATURDAY');
  }
  if (workday.value[6].chk) {
    payload.businessDay.push('SUNDAY');
  }

  // ตัวแปร payload ด้านล่างนี้จะได้ค่า infoImgUid และ stampImgUid ล่าสุดพ่วงไปด้วยเรียบร้อยแล้ว
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await stores.shopUpdateFetch(payload);
  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        // ล้างสเตตัสไฟล์ใหม่ให้เปลี่ยนเป็นไฟล์เก่าทั้งหมด หลังจากอัปเดตร้านค้าสำเร็จ
        fileData.img1.isNewFile = false;
        fileData.img2.isNewFile = false;
        await getshopInfo()
        swal("บันทึกสำเร็จ", "", "success");
      } else {
        swal("บันทึกไม่สำเร็จ", "", "error");
      }
    }
  }
}

async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}



async function selectCus(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

function clearCus() {
  cusUid_search.value = ""
  cusName_search.value = ""
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  const response = await storecus.searchCustomerFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function customerInfo(uid) {
  let cusdetail = null
  let data = "";
  data = {
    uid: uid,
  };
  const payload = data;
  const response = await storecus.customerInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (response.data.data !== null) {
          cusdetail = response.data.data;
          cusName_search.value = cusdetail.nameTh
        }
      }
    }
  }
}

const handleFileChange = (event, key) => {
  // จุดสำคัญ: ต้องระบุ [0] เพื่อเอาไฟล์แรกที่ผู้ใช้เลือกเสมอ
  const file = event.target.files[0]; 
  
  if (file) {
    // 1. สร้าง URL จำลองเพื่อนำไปแสดงผลบนหน้าจอทันที (Preview)
    previews[key] = URL.createObjectURL(file); 
    
    // 2. ใช้ FileReader แปลงไฟล์รูปภาพเป็น Base64 String เพื่อเตรียมส่ง API
    const reader = new FileReader();
    reader.onload = (e) => {
      fileData[key] = {
        base64: e.target.result, // ผลลัพธ์ Base64 เต็มรูปแบบ
        name: file.name,         // ชื่อไฟล์เดิม เช่น shop.jpg
        mimeType: file.type,     // ประเภทไฟล์ เช่น image/jpeg
        isNewFile: true          // เปิดสเตตัสแจ้งระบบว่านี่คือรูปภาพใหม่ที่ต้องทำการอัปโหลด
      };
      console.log(`เตรียมอัปโหลดไฟล์ ${key} สำเร็จ:`, fileData[key].name);
    };
    reader.readAsDataURL(file);
  } else {
    // กรณีผู้ใช้กดยกเลิกการเลือกไฟล์
    previews[key] = '';
    fileData[key] = { base64: '', name: '', mimeType: '', isNewFile: false };
  }
}

const cleanBase64 = (base64String) => {
  if (!base64String) return "";
  const regex = /^data:image\/\w+;base64,/;
  return String(base64String).replace(regex, "");
}

async function getFileImg(imageUid, uid, key) {
  // หากไม่มี imageUid หรือค่าว่าง ให้ข้ามไปไม่ต้องดึงข้อมูล
  if (!imageUid) return;

  let data = {
    shopUid: uid, // โครงสร้างเดิมของคุณ (หมายเหตุ: ตรวจสอบอีกครั้งว่าดึงค่า key ถูกต้องไหม)
    uid: imageUid,
  };
  
  const payload = data;
  const response = await storedoc.imgAdminInfoFetch(payload);
  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        
        // แปลง Base64 เป็นไฟล์ blob ตามฟังก์ชันเดิมของคุณ
        const file = getFileFromBase64(response.data.data.data, response.data.data.name);
        const dataUrl = URL.createObjectURL(file);
        
        // 1. นำข้อมูลไปใส่ในตัวแปรพรีวิวเพื่อโชว์บนหน้าเว็บทันที
        previews[key] = dataUrl;
        
        // 2. เก็บสถานะไฟล์และข้อมูลเดิมไว้ (เผื่อใช้ตรวจสอบหรือส่งซ้ำ)
        fileData[key] = {
          base64: response.data.data.data,
          name: response.data.data.name,
          mimeType: file.type
        };

        // ถ้าคุณมีตัวแปรเก็บ UID ของรูปภาพเพื่อทำฟอร์มแก้ไข ให้แมปค่ากลับไปด้วย
        if (key === 'img1') thumb_id_1.value = imageUid;
        if (key === 'img2') thumb_id_2.value = imageUid;
        
      }
    }
  }
}

function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  // const trimmedString = string64;
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


</script>

<style lang="scss" scoped></style>